import { NotificationStream } from './notificationStream';

export class NotificationStreamCommand {
  command: string;

  constructor(command: string) {
    this.command = command;
  }
}

export class NotificationStreamCommandJoin extends NotificationStreamCommand {
  constructor() {
    super('join');
  }
}

export class NotificationStreamCommandLoad extends NotificationStreamCommand {
  notifications: NotificationStream[];
  unseen: number;
  unread: number;
  unit: number;

  constructor(unit: number) {
    super('load_recruiter_applicants');
    this.unit = unit;
  }
}

export class NotificationStreamCommandSend extends NotificationStreamCommand {
  notification: NotificationStream;
  unit: number;

  constructor(unit: number) {
    super('send');
    this.unit = unit;
  }
}

export class NotificationStreamCommandMarkAllSeen extends NotificationStreamCommand {
  unseen: number;
  unread: number;
  unit: number;

  constructor(unit: number) {
    super('mark_all_seen_recruiter');
    this.unit = unit;
  }
}

export class NotificationStreamCommandMarkUnitRoomRead extends NotificationStreamCommand {
  unseen: number;
  unread: number;
  unit: number;
  unit_room: number;

  constructor(unit: number, unitRoom: number) {
    super('mark_unit_room_read_recruiter');
    this.unit = unit;
    this.unit_room = unitRoom;
  }
}
